import pqiPresentation from '../assets/experience/PQI.pdf';
import cadSelection from '../assets/experience/CAD/cad-selection.pdf';

const experienceData = [
    {
        title: "Gfuture Engineer",
        company: "Gerdau North America",
        startDate: "June 2025",
        endDate: "Present",
        description: `Description loading...`,
    },
    
    {
        title: "Contract Software Developer",
        company: "Grace Apple Medical LLC",
        startDate: "February 2025",
        endDate: "March 2025",
        description: `
        <div class="project-description">
  <h2>Project Overview</h2>
  <p>
    I designed, hosted, and implemented a comprehensive web solution for a medical practice, utilizing modern web development tools and techniques to ensure a seamless user experience and secure, scalable performance. The project was hosted on a Squarespace domain, allowing for easy integration and management of content while maintaining flexibility with custom development.
  </p>

  <h3>Key Technologies</h3>
  <ul>
    <li><strong>Vue.js</strong>: JavaScript framework for building dynamic web interfaces.</li>
    <li><strong>TypeScript</strong>: Superset of JavaScript that enhances type safety and scalability of the application.</li>
    <li><strong>Cloudflare SSL</strong>: Security layer ensuring encrypted communication between the server and end-users.</li>
  </ul>

  <h3>Development Practices</h3>
  <p>
    I implemented <strong>UX/UI design practices</strong> throughout the project to ensure a seamless and intuitive user experience. The design focused on accessibility, responsiveness, and ease of navigation. Key elements included:
  </p>
  <ul>
    <li>Optimized design for both desktop and mobile devices, ensuring users could access information easily across all screen sizes.</li>
    <li>Clear calls to action and intuitive navigation for appointment scheduling, service inquiries, and contact details.</li>
    <li>Implementation of user-friendly interfaces that provide patients with clear and direct information about the practice.</li>
  </ul>

  <h3>Security and Performance</h3>
  <p>
    The web solution was deployed with <strong>Cloudflare SSL</strong> for secure data transmission, ensuring all sensitive information between patients and the medical practice was encrypted and protected. This was essential for maintaining the trust of patients and complying with data privacy regulations.
  </p>

  <p>
    By using modern web technologies and following industry best practices, I was able to deliver a secure, scalable, and user-friendly web solution that meets the specific needs of the medical practice and its patients.
  </p>

</div>
      `,
        documents: [{ type: "website", "link": "www.graceapple.com" }]
    },

    {
        title: "Programming Engineer Technician",
        company: "Electro-Mechanical Inc.",
        startDate: "December 2024",
        endDate: "May 2025",
        description: `
        <div class="project-description">
  <h2>Project Overview</h2>
  
  <h3>Mechanical Switch C/O Operation Testing</h3>
  <p>
    I developed and introduced a control system for conducting <strong>Mechanical Switch C/O Operation Testing</strong> using <strong>SEL849 Relay</strong> and <strong>SEL-3421 HMI</strong>. This system featured both <strong>automatic</strong> and <strong>manual modes</strong>, providing flexibility for operators. I also implemented <strong>operator safety features</strong> to ensure safe and efficient operation during testing.
  </p>
  <p>
    I created precise <strong>wiring</strong> and <strong>block diagrams</strong> using <strong>AutoCAD LT</strong>, supporting installation and system understanding. I used <strong>Ladder Logic</strong>, <strong>Truth Tables</strong>, and <strong>SELogic</strong> in <strong>AcSELerator</strong> to program the relay, ensuring proper functionality in both operational modes.
  </p>
  <p>
    As part of the project, I also drafted a <strong>proposal for future improvements</strong>, focusing on scalability, enhanced features, and system optimization.
  </p>

  <h3>Database of Test Reports and Data</h3>
  <p>
    I designed and integrated a <strong>Database of Test Reports, Test Data, Inspection Reports, and Standards Protocols</strong> using a combination of <strong>Microsoft Excel</strong>, <strong>Microsoft Forms</strong>, <strong>Power Automate</strong>, and <strong>Java</strong>. The database logged and tracked over <strong>400 documents</strong>, improving document management, reporting, and accessibility.
  </p>
  <p>
    The use of <strong>Microsoft Forms</strong> and <strong>Power Automate</strong> streamlined data entry and processing, while <strong>Excel</strong> and <strong>Java</strong> were used to manage and manipulate data efficiently.
  </p>

  <h3>Rockwell and Allen-Bradley Components</h3>
  <p>
    I experimented with <strong>Rockwell</strong> and <strong>Allen-Bradley components</strong> while implementing a database to store <strong>functional off-book spare parts</strong>. This allowed for better maintenance tracking and reduced downtime by ensuring that spare parts were readily available and easily accessible.
  </p>

  <h3>Automated Patent Analysis</h3>
  <p>
    I created an <strong>automated patent analysis</strong> tool using <strong>Python</strong>, the <strong>Gemma API</strong>, and the <strong>US Patent Office API</strong>. This tool streamlined patent research and analysis by automating the data retrieval and processing, making it faster and more accurate to identify and assess patents of interest.
  </p>

</div>
        `
        ,
    },


    {
        title: "Peer Learning Assistant (Tutor)",
        company: "Vol Study Center @ The University of Tennessee Knoxville",
        startDate: "November 2022",
        endDate: "May 2025",
        description: `
        <div class="project-description">
  <h2>Project Overview</h2>

  <h3>STEM Coursework Assistance</h3>
  <p>
    I offered <strong>STEM coursework</strong> assistance in subjects like <strong>MATLAB</strong>, <strong>C</strong>, and <strong>C++</strong> for undergraduate students through personalized <strong>1-on-1 study sessions</strong>. These sessions were typically 30 minutes or 1 hour long, designed to help students understand complex concepts and solve specific problems they encountered. The focus was on individualized attention to ensure that each student could make measurable progress in their coursework.
  </p>

  <h3>Review Rally Pre-Exam Study Sessions</h3>
  <p>
    In addition to 1-on-1 sessions, I also led <strong>lecture-based "Review Rally" pre-exam study sessions</strong> that lasted <strong>2.5 hours</strong>. These sessions were aimed at preparing students for upcoming exams by reviewing key concepts, answering questions, and providing problem-solving strategies. The sessions fostered a collaborative learning environment where students could interact with their peers and engage in active learning to enhance their understanding and boost their exam readiness.
  </p>
</div>

      `,
        documents: [{ type: "website", "link": "https://www.youtube.com/@mmckin22" }]
    },



    {
        title: "Student Software Developer / Integrator",
        company: "Electric Power Research Institute (EPRI)",
        startDate: "May 2023",
        endDate: "September 2024",
        description: `
        <div class="project-description">
  <h2>Project Overview</h2>

  <h3>PQI Webtool Development</h3>
  <p>
    I worked on the development of the <strong>PQI Webtool</strong>, a proprietary tool for the <strong>Electric Power Research Institute (EPRI)</strong>, where I specifically developed the <strong>navigator</strong> and <strong>tools pages</strong> to display data in a more modern and user-friendly structure.
  </p>

  <h3>Frontend Development</h3>
  <p>
    On the frontend, I restructured the <strong>navigator</strong> to simplify the drill-down process. Previously, users were required to select all necessary information in one step, which could be cumbersome. For example, to see common components used in the wood industry, a user would need to select: 
    <ul>
      <li>Wood Industry</li>
      <li>One of the Processes</li>
      <li>A piece of Equipment</li>
    </ul>
    Only then would they see the common components in that particular piece of equipment. 
    <br><br>
    I decided to maintain this functionality for specific data but also implemented a more intuitive approach where all relevant processes, components, and equipment are displayed at every level. The displayed information dynamically narrows as the user selects more options, providing a much smoother user experience.
  </p>

  <h3>Tools Page Redesign</h3>
  <p>
    Before my work, the <strong>tools page</strong> displayed hyperlinks to various tools, which lacked organization and made navigation more difficult. I chose to group the pages based on content type and redesigned the page using modern <strong>cards</strong> and solutions, enhancing the aesthetic and usability of the user interface (UX). This made the tools more accessible and visually appealing for users.
  </p>

  <h3>Database Refactoring</h3>
  <p>
    On the backend, I helped <strong>refactor the SQL tables</strong> that powered the navigator. My work involved eliminating the need for multiple page tables, simplifying the relationships in the database without losing any critical data. I also took responsibility for formatting existing data and adding new data to be displayed in the webtool.
  </p>

  <h3>Training Material Creation</h3>
  <p>
    My work culminated in the creation of <strong>training material</strong> specific to EPRI. With permission from my project manager, I was able to take a subset of this training material and use it to showcase the work I accomplished during the project. This material helped to onboard and train others, ensuring they could understand and effectively use the new features I developed in the webtool.
  </p>

  <h3> CAD Icons </h3>
  <p>
      In addition to my software development, I used OnShape CAD services to create icons for new equipment in the PQI. 
  </p>
  
</div>       
      `,
        recognitions: ["WATTS UP Toastmasters Rookie of the Year Award 2023"],
        documents: [{ type: "Portfolio", link: pqiPresentation }, {type: "CAD", link: cadSelection}]
    },

    {
        title: "Data Entry Clerk",
        company: "Arnhem Postal History Project @ George Mason University",
        startDate: "September 2023",
        endDate: "April 2024",
        description: `
     <div class="project-description">
  <h2>Project Overview</h2>
  <p>
    I contributed to a <strong>postal history project</strong> focused on mapping correspondence during the <strong>Nazi-Occupied Netherlands</strong>. Leveraging my expertise in the <strong>German language</strong> and <strong>Nazi-era history</strong>, I played a key role in ensuring the accuracy and integrity of the project by helping to transcribe, organize, and analyze historical documents, primarily postcards, exchanged during the occupation.
  </p>

  <h3>Contributions:</h3>

  <h4>1. Language Expertise</h4>
  <p>
    - Utilized my <strong>fluency in German</strong> and extensive knowledge of <strong>historical context</strong> to <strong>accurately transliterate</strong> both <strong>Dutch</strong> and <strong>German postcards</strong>. This required careful attention to the nuances of language and history to preserve the intended meaning of the correspondence.
  </p>
  <p>
    - Ensured <strong>precise interpretation</strong> of historical documents, contributing to the overall accuracy of data entry. This allowed for the creation of reliable records for further analysis and mapping.
  </p>

  <h4>2. Database Management</h4>
  <p>
    - Managed an <strong>Excel-based database</strong> that organized and mapped correspondence. I applied an efficient system to track each piece of correspondence, allowing for easy access and analysis.
  </p>
  <p>
    - Implemented <strong>concise and consistent keywording practices</strong> to enhance the clarity and searchability of the data, making it easier for future researchers to navigate and extract relevant information.
  </p>
  <p>
    - Worked with the understanding that the <strong>Excel database</strong> would eventually transfer to a <strong>Django database</strong>, ensuring that the data structure would be adaptable for future database integration.
  </p>

  <h4>3. Attention to Detail</h4>
  <p>
    - Maintained a meticulous approach to <strong>data formatting and transcription</strong>, ensuring historical integrity was preserved. This careful attention to detail was critical for creating accurate, usable data that could be trusted by historians and researchers.
  </p>
  <p>
    - Focused on <strong>historical usability</strong>, ensuring the information was not only accurate but also accessible and beneficial for future historical analysis.
  </p>

  <h3>Key Skills Used:</h3>
  <ul>
    <li><strong>German Language Fluency</strong>: Leveraging linguistic expertise to accurately transcribe and interpret postcards in German and Dutch.</li>
    <li><strong>Historical Analysis</strong>: Applying knowledge of Nazi-era history to understand the context behind the correspondence.</li>
    <li><strong>Data Organization</strong>: Using Excel to structure and organize large datasets efficiently.</li>
    <li><strong>Keywording and Metadata Standardization</strong>: Ensuring consistent and accurate metadata for better data retrieval and analysis.</li>
  </ul>
</div>

        `,

    },

    {
        title: "Manager",
        company: "McDonald's",
        startDate: "2017",
        endDate: "2018",
        description: `
          <div class="project-description">
            <h2>Project Overview</h2>
            <p>
              Managed a team of employees at McDonald's, ensuring smooth daily operations, maintaining customer satisfaction, and handling team conflicts. Trained new employees, optimized workflows, and managed inventory and ordering processes to ensure a streamlined service.
            </p>
            <h3>Key Achievements:</h3>
            <ul>
              <li>Led a team of employees, improving customer service response times.</li>
              <li>Trained and onboarded new team members, helping reduce turnover.</li>
              <li>Improved efficiency in order management and inventory systems, reducing waste and costs.</li>
            </ul>
          </div>
        `,
        recognitions: ["Achieved fastest drive through time in location history."],
        certifications: ["ServSafe Food Safety"]
    },

];

export default experienceData;
